<!-- components/Selectores/AutoSelectorSinVersion.vue -->
<template>
  <div class="flex flex-col gap-3">
    <SelectMasInput
      :data="marcas_para_select"
      placeholderName="Marca"
      :isLoading="loadingMarcas"
      :isEnabled="!loadingMarcas"
      :selectedValue="selectedMarca"
      :usar_store_plp="false"
      :disableAutoScroll="true"
      customClassPadre="w-full"
      customClassTrigger="h-11 px-4 py-3 text-base rounded-xl bg-white"
      customClassInput="h-11 px-4 py-3 text-base rounded-xl bg-white focus:border-[#4299e1] focus:shadow-[0_0_0_1px_rgba(66,153,225,0.5)]"
      customClassDropdown="bg-BLANCO_LEON rounded-md border border-[#e2e8f0] shadow-md max-h-[250px] px-0"
      @setSelectMasInput="onAbrirMarcas"
      @changeValue="onMarcaChange"
    />

    <SelectMasInput
      :data="anos"
      placeholderName="Año"
      :isLoading="loadingAnos"
      :isEnabled="tiene_valor(selectedMarca) && !loadingAnos && anos.length > 0"
      :isMeasure="true"
      :selectedValue="selectedAno"
      :usar_store_plp="false"
      :disableAutoScroll="true"
      customClassPadre="w-full"
      customClassTrigger="h-11 px-4 py-3 text-base rounded-xl bg-white"
      customClassInput="h-11 px-4 py-3 text-base rounded-xl bg-white focus:border-[#4299e1] focus:shadow-[0_0_0_1px_rgba(66,153,225,0.5)]"
      customClassDropdown="bg-BLANCO_LEON rounded-md border border-[#e2e8f0] shadow-md max-h-[250px] px-0"
      @changeValue="onAnoChange"
    />

    <SelectMasInput
      :data="modelos_para_select"
      placeholderName="Modelo"
      :isLoading="loadingModelos"
      :isEnabled="!!selectedAno && !loadingModelos && modelos_para_select.length > 0"
      :selectedValue="selectedModelo"
      :usar_store_plp="false"
      :disableAutoScroll="true"
      customClassPadre="w-full"
      customClassTrigger="h-11 px-4 py-3 text-base rounded-xl bg-white"
      customClassInput="h-11 px-4 py-3 text-base rounded-xl bg-white focus:border-[#4299e1] focus:shadow-[0_0_0_1px_rgba(66,153,225,0.5)]"
      customClassDropdown="bg-BLANCO_LEON rounded-md border border-[#e2e8f0] shadow-md max-h-[250px] px-0"
      @changeValue="onModeloChange"
    />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import SelectMasInput from "~/components/Selectores/SelectMasInput.vue";
import { useStore } from "vuex";

const store = useStore();
const emit = defineEmits(["carSelected"]);
const { getBrands, getYears, getModels } = useWheelSize();

//#region STORE
const searchData = computed(() => store.getters["aceites/getSearchData"]);
const selectedMarca = computed(() => searchData.value.marca);
const selectedAno = computed(() => searchData.value.ano);
const selectedModelo = computed(() => searchData.value.modelo);
//#endregion

//#region STATE
const marcas = ref([]);
const anos = ref([]);
const modelos = ref([]);

const isMarcasLoaded = ref(false);
const loadingMarcas = ref(false);
const loadingAnos = ref(false);
const loadingModelos = ref(false);

let reqMarca = 0;
let reqAno = 0;
let reqModelo = 0;
//#endregion

//#region SESSION STORAGE
const CACHE_MARCAS = 'aceites_marcas';
const CACHE_ANOS = 'aceites_anos';
const CACHE_MODELOS = 'aceites_modelos';

const saveToSessionStorage = (key, value, contexto = {}) => {
  sessionStorage.setItem(key, JSON.stringify({ data: value, ...contexto }));
};

const readFromSessionStorage = (key) => {
  const value = sessionStorage.getItem(key);
  return value ? JSON.parse(value) : null;
};
//#endregion

//#region HELPERS
const esNumero = (v) => {
  if (v === null || v === undefined || v === "") return false;
  return Number.isFinite(Number(v));
};

const aNumeroSiCorresponde = (v) => (esNumero(v) ? Number(v) : v);
const normNombre = (x) => x?.nombre ?? x?.name ?? x?.label ?? x?.modelo ?? x?.brand ?? "";
const normId = (x) => aNumeroSiCorresponde(x?.id ?? x?.value ?? x);
const tiene_valor = (v) => v !== '' && v !== null && v !== undefined;

const marcas_para_select = computed(() =>
  (marcas.value || []).map(m => ({ id: m.id, name: m.nombre, logo: m.logo }))
);

const modelos_para_select = computed(() =>
  (modelos.value || []).map(m => ({ id: m.id, name: m.nombre }))
);

const normalizarMarcas = (lista) => {
  if (!Array.isArray(lista)) return [];
  return lista
    .map((x) => ({
      id: normId(x),
      nombre: normNombre(x),
      logo: x?.logo ?? x?.image ?? x?.imagen ?? x?.icon ?? "",
    }))
    .filter((x) => x.id !== "" && x.nombre);
};

const normalizarModelos = (lista) => {
  if (!Array.isArray(lista)) return [];
  return lista
    .map((x) => ({ id: normId(x), nombre: normNombre(x) }))
    .filter((x) => x.id !== "" && x.nombre);
};

const normalizarAnos = (lista) => {
  if (!Array.isArray(lista)) return [];
  return lista
    .map((x) => aNumeroSiCorresponde(x?.year ?? x?.anno ?? x?.ano ?? x?.id ?? x))
    .filter((y) => y !== "" && Number.isFinite(Number(y)));
};

const obtener_logo_marca = (marcaId) => {
  if (!marcaId) return "";
  const m = (marcas.value || []).find(x => String(x.id) === String(marcaId));
  return m?.logo || "";
};

const emitirSeleccion = ({ marca, ano, modelo, marca_logo }) => {
  const logo = marca_logo ?? (marca ? obtener_logo_marca(marca) : "");
  emit("carSelected", {
    marca: marca ?? "",
    marca_logo: logo,
    ano: ano ?? "",
    modelo: modelo === null || modelo === undefined ? "" : String(modelo),
  });
};
//#endregion

//#region LOADERS
const loadMarcas = async () => {
  const cache = readFromSessionStorage(CACHE_MARCAS);
  if (cache && cache.data.length > 0) {
    marcas.value = cache.data;
    //console.log("debugear2: ", marcas.value);
    return;
  }

  //console.log("debugear3: ");
  const ticket = ++reqMarca;
  loadingMarcas.value = true;
  try {
    //console.log("debugear3.1: ");
    const lista = await getBrands();
    //console.log("debugear4: ", lista);
    if (ticket !== reqMarca) return;
    marcas.value = normalizarMarcas(lista);
    saveToSessionStorage(CACHE_MARCAS, marcas.value);
  } catch (e) {
    console.error("wheel-size: error marcas", e);
    marcas.value = [];
    isMarcasLoaded.value = false;
  } finally {
    if (ticket === reqMarca) loadingMarcas.value = false;
  }
};

const loadAnos = async (marcaId) => {
  const cache = readFromSessionStorage(CACHE_ANOS);
  if (cache && cache.marca === marcaId && cache.data.length > 0) {
    anos.value = cache.data;
    return;
  }

  const ticket = ++reqAno;
  loadingAnos.value = true;
  try {
    const lista = await getYears(marcaId);
    if (ticket !== reqAno) return;
    anos.value = normalizarAnos(lista);
    saveToSessionStorage(CACHE_ANOS, anos.value, { marca: marcaId });
  } catch (e) {
    console.error("wheel-size: error años", e);
    anos.value = [];
  } finally {
    if (ticket === reqAno) loadingAnos.value = false;
  }
};

const loadModelos = async (marcaId, ano) => {
  const cache = readFromSessionStorage(CACHE_MODELOS);
  if (cache && cache.marca === marcaId && cache.ano === ano && cache.data.length > 0) {
    modelos.value = cache.data;
    return;
  }

  const ticket = ++reqModelo;
  loadingModelos.value = true;
  try {
    const lista = await getModels(marcaId, ano);
    if (ticket !== reqModelo) return;
    modelos.value = normalizarModelos(lista);
    saveToSessionStorage(CACHE_MODELOS, modelos.value, { marca: marcaId, ano });
  } catch (e) {
    console.error("wheel-size: error modelos", e);
    modelos.value = [];
  } finally {
    if (ticket === reqModelo) loadingModelos.value = false;
  }
};
//#endregion

//#region HANDLERS
const onAbrirMarcas = async () => {
  if (isMarcasLoaded.value && marcas.value.length > 0) return;
  isMarcasLoaded.value = true;
  await loadMarcas();
};

const onMarcaChange = async (marcaRaw) => {
  const marca = aNumeroSiCorresponde(marcaRaw);
  const marca_logo = marca ? obtener_logo_marca(marca) : "";

  anos.value = [];
  modelos.value = [];
  emitirSeleccion({ marca, marca_logo, ano: "", modelo: "" });

  if (!tiene_valor(marca)) return;

  await loadAnos(marca);

  if (anos.value.length === 1) {
    const unicoAno = anos.value[0];
    emitirSeleccion({ marca, marca_logo, ano: unicoAno, modelo: "" });

    await loadModelos(marca, unicoAno);

    if (modelos.value.length === 1) {
      emitirSeleccion({ marca, marca_logo, ano: unicoAno, modelo: modelos.value[0].id });
    }
  }
};

const onAnoChange = async (anoRaw) => {
  const ano = aNumeroSiCorresponde(anoRaw);
  const marca_logo = selectedMarca.value ? obtener_logo_marca(selectedMarca.value) : "";

  modelos.value = [];
  emitirSeleccion({ marca: selectedMarca.value, marca_logo, ano, modelo: "" });

  if (!selectedMarca.value || !ano) return;

  await loadModelos(selectedMarca.value, ano);

  if (modelos.value.length === 1) {
    emitirSeleccion({ marca: selectedMarca.value, marca_logo, ano, modelo: modelos.value[0].id });
  }
};

const onModeloChange = (modeloRaw) => {
  const modelo = aNumeroSiCorresponde(modeloRaw);
  const marca_logo = selectedMarca.value ? obtener_logo_marca(selectedMarca.value) : "";
  emitirSeleccion({ marca: selectedMarca.value, marca_logo, ano: selectedAno.value, modelo });
};
//#endregion

//#region LIFECYCLE
onMounted(async () => {
  console.log("onMounted components/Selectores/AutoSelectorSinVersion.vue")
  const marcaStored = aNumeroSiCorresponde(selectedMarca.value);
  const anoStored = aNumeroSiCorresponde(selectedAno.value);
  //console.log("debugear0: ", marcaStored);
  if (!marcaStored) { return; }

  //console.log("debugear1: ", marcaStored);
  await loadMarcas();
  isMarcasLoaded.value = true;
  await loadAnos(marcaStored);

  if (anoStored) {
    await loadModelos(marcaStored, anoStored);
  }
});
//#endregion
</script>